import { useMemo } from 'react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { WITHOUT_OVERHANG, WITH_OVERHANG } from '@/features/types';
import type { FilterState } from '@/features/filterSlice';
import { InputSelect } from '@/components/InputSelect/InputSelect';
import type { Option } from '@/components/InputSelect/InputSelect';
import { useClientTerminology } from '@/views/list/NetworkTerms';

export const OverhangFilter = (props: { control: Control<FilterState> }) => {
  const intl = useClientTerminology();

  const options: Option[] = useMemo(
    () => [
      {
        value: WITH_OVERHANG,
        label: intl.formatMessage({ id: 'filter.withOverhangLabel' }),
      },
      {
        value: WITHOUT_OVERHANG,
        label: intl.formatMessage({ id: 'filter.withoutOverhangLabel' }),
      },
    ],
    [intl]
  );

  return (
    <Controller
      control={props.control}
      name="encroachmentType"
      render={({ field: { onChange, onBlur, value } }) => (
        <OverhangFilterInput
          options={options}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={intl.formatMessage({
            id: 'filter.allEncroachmentTypesLabel',
          })}
          label={intl.formatMessage({ id: 'filter.encroachmentTypeLabel' })}
        />
      )}
    />
  );
};

const OverhangFilterInput = (props: {
  options: Option[];
  value: string[];
  onChange: (next: string[]) => void;
  onBlur: () => void;
  placeholder: string;
  label: string;
}) => {
  const { options, value, onChange, onBlur, placeholder, label } = props;

  const selectedValue = useMemo(
    () => options.filter((o) => o.value !== null && value.includes(o.value)),
    [options, value]
  );

  return (
    <InputSelect
      isMulti
      placeholder={placeholder}
      label={label}
      options={options}
      value={selectedValue}
      onChange={(next) => onChange(next as string[])}
      onBlur={onBlur}
    />
  );
};
